module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 276
// module chunks = 0